<template>
	<div>
    <div class="top-nav">
      <teams-overview :classObj="classObj" :teams="teams" v-if="station" :class="classObj" />
      <screen-indicator :token="presentationScreenToken" :haveScreen="haveScreen && connected" v-if="station"></screen-indicator>
    </div>
		<div v-if="loading">
			<p>Loading...</p>
		</div>
		<router-view v-else :classUuid="classUuid" @stationsOverview="clearStation"></router-view>
	</div>
</template>

<script>
import Station from './Station';
import ScreenIndicator from './ScreenIndicator.vue';
import TeamsOverview from "./TeamsOverview.vue";

import { cmsService } from '../../components/services';
import {catchUp} from "../../components/state-calculator";

export default {
	name: 'App',
	components: {
    TeamsOverview,
		Station,
		ScreenIndicator,
	},
	props: {
		classUuid: null,
		presentationScreenToken: '',
	},
	data() {
		return {
			loading: true,
			haveScreen: false,
			connected: false,
      classObj: {},
		};
	},
	computed: {
		station() {
			return this.$actions.getStation(this.$store.stationUuid);
		},
    teams(){
      return this.$actions.getTeams();
    }
	},
    watch: {
        station(){
            if(this.station){
                this.$router.push({ name: 'station', params: { uuid: this.station.uuid } });
            }else{
                this.$router.push({ name: 'stations'});

            }
        }
    },
	methods: {
		clearStation() {
			this.$actions.setSlide(null);
			this.$actions.setStationUuid(null);
		},
	},
	mounted() {
		document.addEventListener('class.slide-subcommand-event', evt => {
			this.$eventBus.$emit(evt.data.name, evt.data.data);
		});

		this.$eventBus.$on('set-variable', evt => {
			this.$actions.setVariable(evt.name, evt.value);
		});

		this.$eventBus.$on('connected', value => {
			console.log('connected');
			this.connected = value;
		});

		Promise.all([
			cmsService.getStations().then(res => {
				this.$actions.setStations(res.data.stations);
			}),
			cmsService.getSlides().then(res => {
				this.$actions.setSlides(res.data.slides);
			}),
			cmsService.getTeams(this.classUuid).then(response => {
				this.$actions.setTeams(response.data);
			}),
			cmsService.getClass(this.classUuid).then(response => {
				this.$actions.setClass(response.data);
        this.classObj = response.data;
			}),
		]).then(x => {
			catchUp(this.classUuid).finally(() => {
				this.loading = false;
			});
		});
	},
	created() {
		document.addEventListener('realtime.init', evt => {
			window.channels.forEach(channel => {
				if (/^presence-presentation\./.test(channel.name)) {
					['pusher:subscription_succeeded', 'pusher:member_added', 'pusher:member_removed'].forEach(evtName => {
						channel.subscription.bind(evtName, evt => {
							const members = Object.values(channel.subscription.members.members);
							this.haveScreen = !!members.find(x => x.name == 'presentation');
						});
					});

					channel.listenForWhisper('connected', e => {
						this.connected = true;
					});

					channel.listenForWhisper('disconnected', e => {
						this.connected = false;
					});
				}
			});
		});
	},
};
</script>

<style>

.top-nav {

}

</style>
